import { redirect } from 'react-router';
import { materialsRoute as route } from '@utils/consts';

const routes = [
  {
    path: route.index,
    lazy: async () => {
      const { MaterialsProvider } = await import('@contexts/panel/tenants/materials');
      const { MaterialsRoot } = await import('@components/panel/tenants/materials');
      return {
        Component: () => (
          <MaterialsProvider>
            <MaterialsRoot />
          </MaterialsProvider>
        ),
      };
    },
    children: [
      {
        index: true,
        loader: () => redirect(route.templates),
      },
      {
        path: route.templates,
        lazy: async () => {
          const { MaterialsTemplates } = await import('@pages/panel/materials/templates');
          return {
            Component: () => <MaterialsTemplates />,
          };
        },
      },
      {
        path: route.tags,
        lazy: async () => {
          const { MaterialsTags } = await import('@pages/panel/materials/tags');
          return {
            Component: () => <MaterialsTags />,
          };
        },
      },
    ],
  },
];

export { routes as materialsRoutes };
